export default "__VITE_PUBLIC_ASSET__375c9286__"